
export class GreetingGenerator {
  static getSellerGreeting(merchantName: string, platformInfo: any): string {
    const platform = platformInfo.platform;
    
    // Platform-specific casual greetings for individual sellers
    switch (platform) {
      case 'ebay':
      case 'mercari':
      case 'poshmark':
      case 'depop':
      case 'vinted':
        return `Hi [seller's name]`;
      
      case 'etsy':
        return `Hello [seller's name]`;
      
      case 'facebook_marketplace':
      case 'offerup':
      case 'craigslist':
      case 'nextdoor':
      case 'varagesale':
      case 'fivemiles':
        return `Hi [seller's name]`; // Use placeholder instead of generic "Hi there"
      
      case 'reverb':
        return `Hey [seller's name]`; // Music community is more casual
      
      case 'kidizen':
      case 'tradesy':
      case 'chairish':
        return `Hello [seller's name]`;
      
      case 'gunbroker':
        return `Hello [seller's name]`; // More formal for firearms marketplace
      
      case 'amazon':
        return platformInfo.isPrivateSeller ? `Hello [seller's name]` : `Dear ${merchantName} Support`;
      
      default:
        return platformInfo.isPrivateSeller ? `Hi [seller's name]` : `Dear ${merchantName} Support`;
    }
  }

  static getPlatformName(platform: string): string {
    const platformNames = {
      'ebay': 'eBay',
      'amazon': 'Amazon',
      'etsy': 'Etsy',
      'shopify': 'Shopify',
      'paypal': 'PayPal',
      'facebook_marketplace': 'Facebook',
      'offerup': 'OfferUp',
      'craigslist': 'Craigslist',
      'mercari': 'Mercari',
      'poshmark': 'Poshmark',
      'depop': 'Depop',
      'nextdoor': 'Nextdoor',
      'varagesale': 'VarageSale',
      'vinted': 'Vinted',
      'reverb': 'Reverb',
      'kidizen': 'Kidizen',
      'tradesy': 'Tradesy',
      'chairish': 'Chairish',
      'fivemiles': '5miles',
      'gunbroker': 'GunBroker'
    };
    return platformNames[platform] || platform;
  }
}
